import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();

  if (!ready || user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-smj" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/set-password" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={(user.role === "client" || user.role === "manager") ? "/portal" : "/firm"} replace />;
  }
  return children;
}
